import { useContext } from 'react';

import { ConfigContext } from '@f/context';

export const useConfig = () => {
  const context = useContext(ConfigContext);
  const config = context?.config;
  if (!config) {
    throw new Error('Config not found');
  }
  return config;
};
